import { render, staticRenderFns } from "./Course-details.vue?vue&type=template&id=24c5759d&scoped=true"
import script from "./Course-details.vue?vue&type=script&lang=js"
export * from "./Course-details.vue?vue&type=script&lang=js"
import style0 from "./Course-details.vue?vue&type=style&index=0&id=24c5759d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5759d",
  null
  
)

export default component.exports